var Opal = require('../opal').default; /* Generated by Opal 0.11.99.dev */
(function(Opal) {
  function $rb_times(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs * rhs : lhs['$*'](rhs);
  }
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_gt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs > rhs : lhs['$>'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $send = Opal.send, $truthy = Opal.truthy, $gvars = Opal.gvars, $range = Opal.range;

  Opal.add_stubs(['$setPrefixes', '$===', '$to_i', '$checkRoll', '$getLifeAndDeathUnknownResult', '$debug', '$!=', '$roll', '$sort', '$collect', '$split', '$concat', '$*', '$size', '$select', '$==', '$+', '$join', '$>', '$each', '$get_table_by_d66']);
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'EndBreaker');

    var $nesting = [self].concat($parent_nesting), $EndBreaker_initialize$1, $EndBreaker_gameName$2, $EndBreaker_gameType$3, $EndBreaker_getHelpMessage$4, $EndBreaker_rollDiceCommand$5, $EndBreaker_checkRoll$6, $EndBreaker_getLifeAndDeathUnknownResult$11;

    
    self.$setPrefixes(["\\d+EB", "LDUT"]);
    
    Opal.def(self, '$initialize', $EndBreaker_initialize$1 = function $$initialize() {
      var $iter = $EndBreaker_initialize$1.$$p, $yield = $iter || nil, self = this, $zuper = nil, $zuper_i = nil, $zuper_ii = nil;

      if ($iter) $EndBreaker_initialize$1.$$p = null;
      // Prepare super implicit arguments
      for($zuper_i = 0, $zuper_ii = arguments.length, $zuper = new Array($zuper_ii); $zuper_i < $zuper_ii; $zuper_i++) {
        $zuper[$zuper_i] = arguments[$zuper_i];
      }
      
      $send(self, Opal.find_super_dispatcher(self, 'initialize', $EndBreaker_initialize$1, false), $zuper, $iter);
      self.sendMode = 2;
      return (self.d66Type = 1);
    }, $EndBreaker_initialize$1.$$arity = 0);
    
    Opal.def(self, '$gameName', $EndBreaker_gameName$2 = function $$gameName() {
      var self = this;

      return "エンドブレイカー"
    }, $EndBreaker_gameName$2.$$arity = 0);
    
    Opal.def(self, '$gameType', $EndBreaker_gameType$3 = function $$gameType() {
      var self = this;

      return "EndBreaker"
    }, $EndBreaker_gameType$3.$$arity = 0);
    
    Opal.def(self, '$getHelpMessage', $EndBreaker_getHelpMessage$4 = function $$getHelpMessage() {
      var self = this;

      return "" + "・判定 (nEB)\n" + "  n個のD6を振る判定。ダブルトリガー発動で自動振り足し。\n" + "・各種表\n" + "  ・生死不明表 (LDUT)\n"
    }, $EndBreaker_getHelpMessage$4.$$arity = 0);
    
    Opal.def(self, '$rollDiceCommand', $EndBreaker_rollDiceCommand$5 = function $$rollDiceCommand(command) {
      var $a, $b, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, diceCount = nil, tableName = nil, text = nil, number = nil, $case = nil, result = nil;

      
      if ($truthy(/(\d+)EB/i['$==='](command))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        diceCount = __last__match__1.$to_i();
        return self.$checkRoll(diceCount);};
      tableName = "";
      text = "";
      number = 0;
      $case = command;
      if ("LDUT"['$===']($case)) {
      tableName = "生死不明表";
      $b = self.$getLifeAndDeathUnknownResult(), $a = Opal.to_ary($b), (text = ($a[0] == null ? nil : $a[0])), (number = ($a[1] == null ? nil : $a[1])), $b;}
      else {return nil};
      result = "" + (tableName) + "(" + (number) + "):" + (text);
      return result;
    }, $EndBreaker_rollDiceCommand$5.$$arity = 1);
    
    Opal.def(self, '$checkRoll', $EndBreaker_checkRoll$6 = function $$checkRoll(diceCount) {
      var $a, $b, $c, $$7, $$8, $$9, self = this, rollCount = nil, result = nil, diceFullList = nil, _ = nil, dice_str = nil, diceList = nil, num = nil, count = nil;

      
      self.$debug("EndBreaker diceCount", diceCount);
      rollCount = diceCount;
      result = "";
      diceFullList = [];
      while ($truthy(rollCount['$!='](0))) {
        
        $c = self.$roll(rollCount, 6), $b = Opal.to_ary($c), (_ = ($b[0] == null ? nil : $b[0])), (dice_str = ($b[1] == null ? nil : $b[1])), $c;
        diceList = $send(dice_str.$split(/,/), 'collect', [], ($$7 = function(i){var self = $$7.$$s || this;

        
          
          if (i == null) {
            i = nil;
          };
          return i.$to_i();}, $$7.$$s = self, $$7.$$arity = 1, $$7)).$sort();
        diceFullList.$concat(diceList);
        rollCount = $rb_times($send(diceList, 'select', [], ($$8 = function(i){var self = $$8.$$s || this;

        
          
          if (i == null) {
            i = nil;
          };
          return i['$=='](1);}, $$8.$$s = self, $$8.$$arity = 1, $$8)).$size(), 2);
        result = $rb_plus(result, "" + "[" + (diceList.$join()) + "]");
        if ($truthy($rb_gt(rollCount, 0))) {
          result = $rb_plus(result, " ダブルトリガー! ")};
      };
      result = $rb_plus(result, " ＞");
      
      ;
      ;
      ;
      $send($range(2, 6, false), 'each', [], ($$9 = function($for_tmp5){var self = $$9.$$s || this, $$10;

      
        
        if ($for_tmp5 == null) {
          $for_tmp5 = nil;
        };
        num = $for_tmp5;
        count = $send(diceFullList, 'select', [], ($$10 = function(i){var self = $$10.$$s || this;

        
          
          if (i == null) {
            i = nil;
          };
          return i['$=='](num);}, $$10.$$s = self, $$10.$$arity = 1, $$10)).$size();
        if ($truthy(count['$=='](0))) {
          return nil
        } else {
          return (result = $rb_plus(result, "" + " [" + (num) + ":" + (count) + "個]"))
        };}, $$9.$$s = self, $$9.$$arity = 1, $$9));;
      return result;
    }, $EndBreaker_checkRoll$6.$$arity = 1);
    return (Opal.def(self, '$getLifeAndDeathUnknownResult', $EndBreaker_getLifeAndDeathUnknownResult$11 = function $$getLifeAndDeathUnknownResult() {
      var self = this, table = nil;

      
      table = [" 1日：生還！", " 1日：生還！", " 1日：生還！", " 1日：生還！", " 1日：生還！", " 1日：生還！", " 1日：生還！", " 5日：敵に捕らわれ、ひどい暴行と拷問を受けた。", " 2日：謎の人物に命を救われた。", "10日：奴隷として売り飛ばされた。", " 8日：おぞましい儀式の生贄として連れ去られた。", " 9日：幽閉・投獄された。", " 1日：生還！", " 7日：モンスター蠢く地下迷宮に滑落した。", "12日強力なマスカレイドにとらわれ、実験台にされた。", " 8日：放浪中に遭遇した事件を、颯爽と解決していた。", " 5日：飢餓状態に追い込まれた。", "15日：記憶を失い放浪した。", " 1日：生還！", "10日：異性に命を救われて、手厚い看病を受けた。", " 3日：負傷からくる熱病で、生死の境を彷徨った。", "11日：闘奴にされたが、戦いと友情の末に自由を獲得した。", " 6日：負傷したまま川に落ち、遥か下流まで流された。", " 9日：敵に連れ去られ、執拗な拷問を受け続けた。", " 1日：生還！", " 4日：繰り返す「死の悪夢」に苛まれた。", " 3日：巨獣の巣に連れ去られた。", "10日：謎の集団に救われて、手厚い看病を受けた。", " 3日：チッタニアンの集落に迷い込み、もてなしを受けた。", " 7日：ピュアリィの群れにとらわれ、弄ばれた。", " 1日：生還！", " 6日：楽園のような場所を発見し、しばらく逗留した。", " 9日：盗賊団に救われ、恩返しとして少し用心棒をした。", "10日：熱病の見せる官能的な幻影にとらわれ、彷徨った。", " 5日：謎の賞金首に狙われ、傷めつけられていた。", " - ：「五分五分」の一般判定。失敗すると死亡。"];
      return self.$get_table_by_d66(table);
    }, $EndBreaker_getLifeAndDeathUnknownResult$11.$$arity = 0), nil) && 'getLifeAndDeathUnknownResult';
  })($nesting[0], $$($nesting, 'DiceBot'), $nesting)
})(Opal);
